// Ctrl+K jump palette for V2 and V3 (2026-10-04): type a page name or a MAIN position symbol, Enter to go.
// Symbols come from one /api/main/positions call per opening (the server caches it for 10 s), never one call per keystroke.
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../lib/api'

const MONO = { fontFamily: 'JetBrains Mono, monospace' }

export default function CommandPalette({ open, onClose, pages }) {
  const navigate = useNavigate()
  const [q, setQ] = useState('')
  const [idx, setIdx] = useState(0)
  const [symbols, setSymbols] = useState([])
  const input = useRef(null)

  useEffect(() => {
    if (!open) return
    setQ(''); setIdx(0)
    setTimeout(() => input.current && input.current.focus(), 0)
    let live = true
    api.mainPositions().then(r => { if (live && r.success) setSymbols(r.positions.map(p => ({ label: `${p.symbol}  ·  MAIN position${p.has_stop ? '' : '  ·  NO STOP'}`, href: `/positions?s=${p.symbol}`, key: p.symbol }))) }).catch(() => {})
    return () => { live = false }
  }, [open])

  const items = useMemo(() => {
    const all = [...pages.map(p => ({ ...p, key: p.href })), ...symbols]
    const t = q.trim().toLowerCase()
    return (t ? all.filter(i => i.label.toLowerCase().includes(t)) : all).slice(0, 12)
  }, [q, pages, symbols])

  if (!open) return null
  const go = (item) => { if (item) { navigate(item.href); onClose() } }
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center pt-24" style={{ background: 'rgba(2,6,23,0.6)' }} onClick={onClose}>
      <div className="rounded-lg border border-cyan-900" style={{ background: '#0f172a', width: 'min(560px, 92vw)' }} onClick={e => e.stopPropagation()}>
        <input ref={input} value={q} onChange={e => { setQ(e.target.value); setIdx(0) }}
          onKeyDown={e => {
            if (e.key === 'Escape') onClose()
            else if (e.key === 'ArrowDown') { e.preventDefault(); setIdx(i => Math.min(i + 1, items.length - 1)) }
            else if (e.key === 'ArrowUp') { e.preventDefault(); setIdx(i => Math.max(i - 1, 0)) }
            else if (e.key === 'Enter') go(items[idx])
          }}
          placeholder="jump to a page or a MAIN position symbol"
          className="w-full bg-transparent px-4 py-3 text-slate-200 outline-none" style={{ ...MONO, fontSize: '0.85rem', borderBottom: '1px solid #1e293b' }} />
        <ul style={{ maxHeight: 340, overflowY: 'auto' }}>
          {items.map((it, i) => (
            <li key={it.key} onMouseEnter={() => setIdx(i)} onClick={() => go(it)}
              style={{ ...MONO, fontSize: '0.74rem', padding: '6px 16px', cursor: 'pointer', color: i === idx ? '#67e8f9' : '#94a3b8', background: i === idx ? 'rgba(8,145,178,0.12)' : 'transparent' }}>
              {it.label}
            </li>
          ))}
          {items.length === 0 && <li style={{ ...MONO, fontSize: '0.72rem', padding: '8px 16px', color: '#64748b' }}>no match</li>}
        </ul>
        <p style={{ ...MONO, fontSize: '0.6rem', color: '#475569', padding: '4px 16px 8px' }}>↑ ↓ choose · Enter go · Esc close</p>
      </div>
    </div>
  )
}
